<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">Second Chances</h1>
<p class="sub"><strong>An inspiring collection of do-overs that have made people’s lives brighter.</strong></p>
<p class="author"><strong>ERIN McHUGH</strong></p>
<p class="pub"><img alt="images" height="23" src="images/pub.jpg" width="205"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?fc00de30